/* Offer code entry.

   The prototype set its own ?code= and rewrote prices itself, because nothing
   behind it was real. On the live site that job belongs to the offer engine,
   snippets/v4-offer-engine.liquid (rendered once by layout/theme.liquid, a
   byte-for-byte copy of OFFER-ENGINE's candidate written by tools/offer-sync.js):
   it reads ?code= on any URL, stores it in the sr_code cookie and applies it in
   the background through /discount/. snippets/v4-offer-display.liquid then draws
   the offer into every price slot on the page.

   So this form does one thing: put the code on the URL and reload. Josh authors
   ?code= only; /discount/ is the engine's plumbing and is never written by hand.
   See memory: dynamic-code-swap, and OFFER-ENGINE/PASTE-STEPS.txt. */
(function () {
  function wire(form) {
    if (form.dataset.v4Wired === 'true') return;
    form.dataset.v4Wired = 'true';

    var status = form.querySelector('[data-offer-status]');
    var note = status ? status.textContent : '';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var input = form.querySelector('input[name="code"]');
      var code = (input ? input.value : '').trim().toUpperCase();

      if (!code) {
        if (status) status.textContent = 'Enter your code and we will apply it.';
        if (input) input.focus();
        return;
      }

      // The same shape the engine validates against before it touches anything.
      if (!/^[A-Z0-9]{2,20}$/.test(code)) {
        if (status) status.textContent = 'That code does not look right. Check your advert, letter or email.';
        if (input) input.focus();
        return;
      }

      if (status) status.textContent = 'Applying your code...';

      var destination = form.dataset.offerRedirect || window.location.pathname;
      var url = new URL(destination, window.location.origin);
      url.searchParams.set('code', code);
      window.location.href = url.pathname + url.search;

      // If the browser blocks the navigation, put the note back.
      window.setTimeout(function () {
        if (status) status.textContent = note;
      }, 4000);
    });
  }

  function init() {
    document.querySelectorAll('[data-offer-form]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
